import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextComponent } from '../../shared/components/form/input-text/input-text.component';
import { InputSelectComponent } from '../../shared/components/form/input-select/input-select.component';
import { InputTextareaComponent } from '../../shared/components/form/input-textarea/input-textarea.component';
import { SharedModule } from '../../shared/shared.module';
import { GeneralComponent } from '@app/modules/template/pages/general/general.component';
import { TemplateRoutingModule } from '@app/modules/template/template.routing';

@NgModule({
  declarations: [
      GeneralComponent,
      InputTextComponent,
      InputSelectComponent,
      InputTextareaComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TemplateRoutingModule
  ]
})
export class TemplateModule { }
